import { createRequestTypes } from '../utils';

export const SHADES_INCI_LIST_FOR_PRODUCT = createRequestTypes('shadeInciList/SHADES_INCI_LIST_FOR_PRODUCT');